<template>
  <div>
    <!--    CABIFY    -->
    <div
      v-if="car.provider==='cabify'"
      class="row no-gutters"
    >
      <div class="col-12 col-lg-4">
        <figure
          class="p-0 pl-5 pr-5 p-lg-3 d-flex justify-content-center align-items-center h-100"
          style="padding: 15px 20px; height: auto; min-height: auto;"
        >
          <img
            class="d-flex"
            src="../../assets/img/transfers/standard.png"
            alt="image car"
            height="100"
          >
          <small style="right: 20px; top:20px">{{ car.product.service_type }}</small>
        </figure>
      </div>
      <div class="col-12 col-lg-8">
        <div class="pr-4 pl-4 p-3 p-lg-4">
          <div class="row">
            <div class="col-12 col-lg-6 p-lg-0">
              <h4 class="p-0 m-0">
                {{ rideNameToShow }}
              </h4>

              <h6 class="color-gray small_h6 mt-2">
                <i class="icon-clock" />
                {{ $t('lang.transfer.arrives_in') + ' ' + car.eta.formatted }}
              </h6>
              <h6 class="color-gray small_h6 mt-2">
                <i class=" icon-direction" />
                {{ $t('lang.transfer.duration') }}
                {{ car.duration/60 }} min ({{ (car.distance/1000).toFixed(1) }} km)
              </h6>

              <h6 class="color-gray small_h6 mt-2">
                <i class="icon-info" />
                {{ car.product.description }}
              </h6>
            </div>

            <div class="col-12 col-lg-6 text-right color-gray mt-lg-0">
              <div>
                <s>$ {{ originalPrice }} {{ car.currency }}</s>
                <h6 class="font-weight-bold mb-3">
                  $ {{ car.total_price }} {{ car.currency }}&nbsp;
                  <span class="small text-success font-weight-normal p-1">
                    {{ discount }}% OFF
                  </span>
                </h6>
              </div>

              <div
                v-if="!selectedCarOption"
                class="text-center text-lg-right"
              >
                <button
                  class="btn btn-main-color mt-lg-2 pl-4 pr-4 book-btn"
                  name="btn_submit"
                  @click="carSelected()"
                >
                  {{ $t('lang.transfer.book') }}
                </button>
                <p class="mt-2 mb-0 small font-weight-bold">
                  {{ $t('lang.transfer.free_cancellation') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    CIVITATIS    -->
    <div
      v-else
      class="row no-gutters"
    >
      <div class="col-12 col-lg-4">
        <figure
          class="p-0 pl-5 pr-5 p-lg-3"
          style="padding: 15px 20px; height: auto; min-height: auto;"
        >
          <img
            class="d-block"
            :src="car.image"
            alt="image car"
            width="100%"
          >
          <small style="right: 20px; top:20px">{{ car.type }}</small>
        </figure>
      </div>
      <div class="col-12 col-lg-8">
        <div class="pr-4 pl-4 p-3 p-lg-4">
          <div class="row">
            <div class="col-12 col-lg-6 p-lg-0">
              <h4 class="p-0 m-0">
                {{ car.label }}
              </h4>

              <h6 class="color-gray small_h6 mt-2">
                <i class="icon-user-2" />
                {{ car.places + $t('lang.transfer.places') }}
              </h6>
              <h6 class="color-gray small_h6">
                <i class="icon-suitcase" />
                {{ car.large_suitcase + $t('lang.transfer.large_suitcase') }}
              </h6>
              <h6 class="color-gray small_h6">
                <i class="icon-bag" />
                {{ car.hand_suitcase + $t('lang.transfer.hand_suitcase') }}
              </h6>
            </div>

            <div class="col-12 col-lg-6 text-right color-gray mt-lg-0">
              <div>
                <s>$ {{ originalPrice }} {{ car.currency }}</s>
                <h6 class="font-weight-bold mb-3">
                  $ {{ car.total_price }} {{ car.currency }}&nbsp;
                  <span class="small text-success font-weight-normal p-1">
                    {{ discount }}% OFF
                  </span>
                </h6>
              </div>

              <div
                v-if="!selectedCarOption"
                class="text-center text-lg-right"
              >
                <button
                  class="btn btn-main-color mt-lg-2 pl-4 pr-4 book-btn"
                  name="btn_submit"
                  @click="carSelected()"
                >
                  {{ $t('lang.transfer.book') }}
                </button>
                <p
                  class="mt-2 mb-0 small"
                  v-html="$t('lang.transfer.cancellation', {hs: car.cancellation})"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarCard',

  props: {
    car: {
      type: Object,
      required: true,
    },
    selectedCarOption: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      originalPrice: 0,
      discount: 0,
    };
  },
  computed: {
    rideNameToShow() {
      let title = this.car.product.name;
      title = title.replace('Cabify', this.$t('lang.transfer.car'));
      title = title.replace('Corp', ' ');

      return title;
    },
  },

  created() {
    this.originalPrice = this.car.total_price + this.car.discount_amount;
    this.discount = Math.round(((this.car.discount_amount / this.originalPrice) * 100));
  },

  methods: {
    carSelected() {
      if (this.car.provider === 'cabify') {
        this.$emit('rideSelected', this.car);
      } else {
        this.$emit('carSelected', this.car);
      }
    },
  },
};
</script>

<style scoped>

.book-btn{
  width: 100%;
  font-size: 1rem;
  font-weight: 600;
}
@media (min-width: 992px) {
  .book-btn{
    width: auto;
  }
}

.text-success{
  padding: .5rem .75rem ;
  font-weight: normal;
  line-height: 1.4;
  background-color: rgba(0, 166, 80, .1);
  color: #00a650;
}

</style>
